<template>
  <page-progress></page-progress>
    <RouterView/>
</template>

<script setup lang="ts">
import PageProgress from '@/components/page-progress/index.vue'
import { useRoute } from 'vue-router'
const route = useRoute()
</script>
